<template>

  <div class="swiper-container" :class="className">
    <div class="swiper-wrapper">
      <span class="swiper-slide text-box" v-for="item in dataSource" :key="item.linkUrl">
        <span class="huopin-info">{{item.userName}}发起拼团</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mySwiper: null,
    }
  },
  props: {
    dataSource: {
      type: Array,
      default: function () {
        return []
      },
    },
    className: '',
  },
  mounted() {
    this.$nextTick(() => {
      if (this.dataSource.length > 1) {
        debugger
        this.mySwiper = new Swiper('.' + this.className, {
          autoplay: 3000, //可选选项，自动滑动
          loop: true,
          direction:'vertical',
          height:15
        })
      }
    })
  },
}
</script>
<style lang="less">
.huopin-info {
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #cacaca;
  &:before {
    content: ' ';
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    margin-right: 0.1rem;
    background: #d8d8d8ff;
    border-radius: 50%;
  }
}
</style>